import { render, staticRenderFns } from "./WsDeCenterSearch.vue?vue&type=template&id=024fade8"
import script from "./WsDeCenterSearch.vue?vue&type=script&lang=js"
export * from "./WsDeCenterSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports